module.exports = __webpack_public_path__ + "static/media/soccer.fae7c91e.svg";